import {ChangeDetectionStrategy, Component, OnInit, Input} from '@angular/core';
import {ProductTechnical} from "../../../model/view/Product";
import {ProductType} from "../../../model/enums/ProductType.enum";

@Component({
  selector: 'v-product-section-technical',
  templateUrl: './product-section-technical.component.html',
  styleUrls: ['./product-section-technical.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSectionTechnicalComponent implements OnInit {
  @Input() technical: ProductTechnical;
  @Input() title;
  @Input() type;
  productType = ProductType;

  constructor() { }

  ngOnInit(): void {
  }

  isAvailable(data) {
    return data ? 'productDetails.yes' : 'productDetails.no';
  }
}
